import React, { useState, useEffect} from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";

// Icons
import LocalShippingTwoToneIcon from "@material-ui/icons/LocalShippingTwoTone";
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ShoppingBasketTwoToneIcon from '@material-ui/icons/ShoppingBasketTwoTone';
import LocalMallIcon from '@material-ui/icons/LocalMall';
// Components
import InventoryItemTable from "./InventoryItemTableView";

//React Router (for getting parameters)
import {  useParams, NavLink } from "react-router-dom";

//number format plugin
import numeral from "numeral";
import MessageBox from "../../components/MessageBox/MessageBox";

//cookies
import {get_cookies, isLoggedIn} from "../../components/Cookies/Cookies";	

//Modal
import SalesModal from "../Sales/SalesModal";
import LoadingModal from "../../components/Modal/LoadingModal";
import PurchaseAddItem from "../Purchases/PurchaseAddItem";
import InventoryItemTableEdit from "./InventoryItemTableEdit";
import { format } from "date-fns";

const useStyles = makeStyles({
	card: {
		marginBottom: "1rem",
	},
	cardHeader: {
		borderBottom: "1px solid #4aba4a",
		padding: "1.3rem 24px 2rem 24px",
	},
	title: {
		marginTop: "0",
		color: "#339933",
		fontWeight: "700",
		fontSize: "1.1rem",
	},
	subTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#339933",
	},
	infoContainer: {
		marginBottom: "2rem",
		backgroundColor: "rgba(137, 200, 59, 0.09)",
		padding: "1rem",
		border: "1.5px solid #4aba4a",
		borderRadius: "5px",
	},
	infoTitle: {
		fontWeight: "700",
		fontSize: "14px",
		width: "calc(75% + 24px)"
	},
	infoContent: {
		fontSize: "14px",
	},
	buttonContainer: {
		textAlign: "right",
		"& button": {
			marginLeft: "0.5rem !important",
		},
	},
	infoTotal: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		marginTop: "1rem",
	},
	infoTotalItem: {
		padding: "0.5rem 1rem",
		border: "1px solid #4aba4a",
		borderRadius: "5px",
		display: "flex",
		alignItems: "center",
		marginBottom: "0.5rem",
		fontWeight: "700",
	},
	infoTotalIcon: {
		marginRight: "0.5rem",
		color: "#4caf50 !important",
	},
	textarea: {
		width: "100%",
		marginTop: "1rem",
	},
});

const InventoryAdjustmentHistoryEdit = () => {
	const { adjno, branchidno } = useParams();
	const [supplierInfo, setSupplierInfo] = useState([]);
	const [warehouse, setWarehouse] = useState([]);
	const classes = useStyles();

	const [items, setItems] = useState([]); //data to display in PO table

	const [poTotal, setPoTotal] = useState(0);
	const [shipTotal, setShipTotal] = useState(0);
	const [grandTotal, setGrandTotal] = useState(0);
	const [notes, setNotes] = useState('');

	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	//Message Box EOF

	//state for disabling/enabling button
	const [btnDisabled, setBtnDisabled] = useState(false);

	//state for managing loading modal
	const [showModal, setShowModal] = useState(false);

	//add item modal
	const [supplierItem, setSupplierItem] = useState([]); //data to display in Add Item dropdown

	//modal message
	const [ modalMessage ] = useState('Please wait...');

	let history = useHistory();

	const addItem = (item) => {

		let found = items.some((x) => (
      x.item_id === item.item_id &&
      x.manufacturing_date === format(new Date(item.manufacturing_date),'yyyy-MM-dd') &&
      x.expiration_date === format(new Date(item.expiration_date),'yyyy-MM-dd') &&
      x.batch_no === item.batch_no
    ));

		if(found){
			//if item is existing in itemArray, add the qty instead
			let newItems = items.map((it)=> {
				if(it.item_id === item.item_id){ //add
					it.qty += item.qty;
			  	}
			  return it;
			});
			setItems(newItems);
		}else{
			//add new unique item to array
			setItems([...items, 
				{
				item_id: item.item_id, 
				qty: item.qty,
				uomDesc: item.uomDesc,
				item_name: item.itemname,
				manufacturing_date:  format(new Date(item.manufacturing_date),'yyyy-MM-dd'),
				expiration_date:  format(new Date(item.expiration_date),'yyyy-MM-dd'),
				batch_no: item.batch_no
				}
			]);
		}	
	}

	const deleteItem = (item_id) => {
		// console.log(item_id);
		let itemArray = items.filter(item => item.item_id != item_id);
		setItems(itemArray);
	}

	// componentDidMount / document.ready ?
	useEffect(() => {
			data();
			// console.log('refresh sir');
	}, []);

	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	const data = async () => {
		await axios.get(process.env.REACT_APP_API_URL+'inv_adjustment_form', {
			params:{
				adjno: adjno,
				jc_u_idno: branchidno
			}
		}).then((res)=>{
			setSupplierInfo(res.data.data[0].general_info);
			setItems(res.data.data[1].item_info);
			setNotes(res.data.data[0].general_info.notes);
		}).catch((error)=>{
			// console.log(error.message);
		})

		await axios.get(process.env.REACT_APP_API_URL+'get_items_for_dropdown', {
		}).then((res)=>{
			setSupplierItem(res.data.data);
		}).catch((error)=>{
			// console.log(error.message);
		})

	};

	const edit_inv_adjustment = async () => {
		setBtnDisabled(true); 
		setShowModal(true); //show loading/please wait modal
		const formData = new FormData();
		formData.append("adjno", adjno);
		formData.append("item_array", JSON.stringify(items));
		formData.append("jc_uname",  get_cookies('username'));
		formData.append("jc_u_idno", get_cookies('branchidno'));
		formData.append("location", supplierInfo.location_id);
		formData.append("type", supplierInfo.type);
		formData.append("notes", notes);
			// adjno:19
			// item_array:[{"item_id":494,"qty":1},↵{"item_id":462,"qty":1}]
			// jc_uname:mdbabaylan
			// jc_u_idno:DAVAOHQ
			// trandate:2021-02-18
			// location:12
			// type:plus
			// notes:updated

		await axios.post(process.env.REACT_APP_API_URL+'edit_inv_adjustment', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
				}

			}).then(function (response) {
				setShowModal(false); //hide loading/please wait modal
				setShowMsgBox(true);
				setMsg("Inventory Adjustment Saved");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
					history.push('/inventory/inventory-adjustment-history');
				}, 2000)
		  	}).catch(function (error) {
				setShowModal(false); //hide loading/please wait modal  
				setShowMsgBox(true);
				setMsg("Something went wrong: "+error);
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
				}, 2500)
	  		});
	}

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<LocalMallIcon />
				</div>
				<NavLink to={"/inventory"}><h2 style={{color:"black"}}>Inventory</h2></NavLink>
				<ArrowForwardIosIcon style={{paddingLeft: "10px", paddingRight: "10px"}}/>
				<NavLink to={"/inventory/inventory-adjustment-history"}><h2 style={{color:"black"}}>Inventory Adjustment History</h2></NavLink>
				<ArrowForwardIosIcon style={{paddingLeft: "10px", paddingRight: "10px"}}/>
				<h2>Inventory Adjustment History Edit #{adjno}</h2>
			</div>
			<div className="page-container">
				<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
				<Card className={classes.card}>
					<div className={classes.cardHeader}>
						<Grid container spacing={0} style={{justifyContent: "flex-end"}}>
							<Grid item xs={8}>
								<div className={classes.subTitle}>
									Inventory Adjustment History Edit
								</div>
								<div className={classes.title}>
									{supplierInfo.title || "Inventory Adjustment Edit"}
								</div>
							</Grid>
							<Grid
								item
								xs={2}
								style={{textAlign: "right"}}
							>
							</Grid>
							<Grid
								item
								xs={2}
								className={classes.buttonContainer}
							>
								 <PurchaseAddItem addItem={addItem} supplierItem={supplierItem}/>
							</Grid>
					  </Grid>
					  	{/* <LoadingModal showModal={showModal}/> */}
							<SalesModal open={showModal} overLayMsg={modalMessage}/>
					</div>
					<CardContent>
						<div className={classes.infoContainer}>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={6}>
									<Grid container spacing={3}>
										<Grid item xs={12} sm={2} className={classes.infoTitle}>
											Location:
										</Grid>
										<Grid
											item
											xs={12}
											sm={10}
											className={classes.infoContent}
										>
											{supplierInfo.location || "Date of delivery"}
										</Grid>
									</Grid>
									<Grid container spacing={3}>
										<Grid item xs={12} sm={2} className={classes.infoTitle}>
											Type: 
										</Grid>
										<Grid
											item
											xs={8}
											sm={10}
											className={classes.infoContent}
										>
											{supplierInfo.adjtype || "Deliver To"}
										</Grid>
									</Grid>
								</Grid>
								<Grid item xs={12} sm={6}>
									<Grid container spacing={3}>
										<Grid item xs={12} sm={4} className={classes.infoTitle}>
											Adjustment No:
										</Grid>
										<Grid
											item
											xs={12}
											sm={8}
											className={classes.infoContent}
										>
											{adjno || ""}
										</Grid>
									</Grid>
									<Grid container spacing={3}>
										<Grid item xs={12} sm={4} className={classes.infoTitle}>
											Transaction Date:
										</Grid>
										<Grid
											item
											xs={12}
											sm={8}
											className={classes.infoContent}
										>
											{supplierInfo.adjustment_date || ""}
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</div>
						<InventoryItemTableEdit items={items} setItems={setItems} deleteItem={deleteItem}/>
						<TextField
							label="Notes"
							multiline
							rows={4}
							variant="outlined"
							value={notes || ''}
							className={classes.textarea}
							onChange={(e)=>{setNotes(e.target.value)}}
						/>
					</CardContent>
				</Card>
				<div className={classes.buttonContainer}>
					<Button disabled={btnDisabled} variant="contained" color="primary" onClick={edit_inv_adjustment}>
						Update
					</Button>
				</div>
			</div>
		</div>
	);
};

export default InventoryAdjustmentHistoryEdit;
